import React, { useState } from "react";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import helpIcon from "../../../../../assets/disabilityIcons/IC_Help.svg";
import CollapseableTable from "../../components/collapseAbleTable/CollapseableTable";
import { Table } from "antd";
import CustomModal from "../../../../../components/styled-components/modal/custom-modal/custom-modal";
import useGetAttributes from "../../hooks/useGetAttributes";
import NewLoader from "../../../../../components/styled-components/loader/NewLoader";
import useCreateAttribute from "../../hooks/useCreateAttribute";
import UseUpdate from "../../hooks/UseUpdate";
import useDeleteItem from "../../hooks/useDeleteItem";
import useModuleData from "../../hooks/useFetchItems";
import { emergencySuppliesCols } from "./AllColumnsData";
import useModalHandlers from "../../hooks/useModalHandler";
import useChangeHandler from "../../hooks/useChangeHandler";
import { ToolTipCreator } from "../../../../../helpers/ToolTipCreator";

const MODULE_NAMES = [
  "Water Supply",
  "Food Inventory",
  "Special Dietary Needs",
  "Medical Devices and Supplies",
  "First Aid Kit Information",
  "Prescription Medications",
  "Emergency Equipment",
  "Flashlights",
  "Batteries",
  "Radio",
  "Phone Chargers",
  "Tools Emergency Supplies Inventory",
  "Clothing and Bedding",
  "Cash Emergency Supplies Inventory",
];

export default function EmergencySuppliesDocumentation() {
  const [loading, setLoading] = useState(false);
  const [selectedIndex, setSelectedIndex] = useState(null);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [modalTitle, setModalTitle] = useState("");
  const [moduleName, setModuleName] = useState(
    "Emergency Supplies Documentation"
  );
  const [formData, setFormData] = useState(null);
  const [attributesData, setAttributesData] = useState(null);
  const history = useHistory();

  const {
    errorState,
    fetchData,
    fieldsData,
    disasterAttributeData,
    loadingState,
    formatModuleKey,
    setTableData,
    setToUpdate,
    toUpdate,
    tableData,
  } = useModuleData(MODULE_NAMES, setLoading);
  const { createAttributes } = useCreateAttribute(
    moduleName,
    formData,
    setFormData,
    setToUpdate,
    fetchData,
    formatModuleKey,
    setTableData,
    setLoading
  );
  const { updateRecord } = UseUpdate(
    formData,
    setFormData,
    fetchData,
    formatModuleKey,
    setTableData,
    setLoading
  );
  const { deleteRecord } = useDeleteItem(
    fetchData,
    formatModuleKey,
    setTableData,
    setLoading
  );
  const { attributes, error } = useGetAttributes(MODULE_NAMES, setLoading);
  const { showModal, updateModal, viewModal, handelCloseModal } =
    useModalHandlers(
      attributes,
      setModalTitle,
      setModuleName,
      setIsModalVisible,
      setFormData,
      setAttributesData
    );
  const { handleChange, handleItemsInfoSelect } = useChangeHandler(setFormData);

  console.log("attributess", attributes);

  const collapseableTables = [
    { title: "Water Supply", key: 1 },
    { title: "Food Inventory", key: 2 },
    { title: "Special Dietary Needs", key: 3 },
    { title: "Medical Devices and Supplies", key: 4 },
    { title: "First Aid Kit Information", key: 5 },
    { title: "Prescription Medications", key: 6 },
    {
      title: "Emergency Equipment",
      key: 7,
    },
    {
      title: "Flashlights",
      key: 8,
    },
    {
      title: "Batteries",

      key: 9,
    },
    { title: "Radio", key: 10 },
    {
      title: "Phone Chargers",
      key: 11,
    },
    {
      title: "Tools",
      originalTitle: "Tools Emergency Supplies Inventory",
      key: 12,
    },
    { title: "Clothing and Bedding", key: 13 },
    {
      title: "Cash",
      originalTitle: "Cash Emergency Supplies Inventory",
      key: 14,
    },
  ];

  const AllColumnsData = emergencySuppliesCols(
    viewModal,
    updateModal,
    deleteRecord
  );

  const tableDataObj = {
    "Water Supply": tableData.waterSupplyData,
    "Food Inventory": tableData.foodInventoryData,
    "Special Dietary Needs": tableData.specialDietaryNeedsData,
    "Medical Devices and Supplies": tableData.medicalDevicesAndSuppliesData,
    "First Aid Kit Information": tableData.firstAidKitInformationData,
    "Prescription Medications": tableData.prescriptionMedicationsData,
    "Emergency Equipment": tableData.emergencyEquipmentData,
    Flashlights: tableData.flashlightsData,
    Batteries: tableData.batteriesData,
    Radio: tableData.radioData,
    "Tools Emergency Supplies Inventory":
      tableData.toolsEmergencySuppliesInventoryData,
    "Phone Chargers": tableData.phoneChargersData,
    "Clothing and Bedding": tableData.clothingAndBeddingData,
    "Cash Emergency Supplies Inventory":
      tableData.cashEmergencySuppliesInventoryData,
  };
  return (
    <div style={{ position: "relative" }}>
      <div className="parent-title-container">
      <div style={{display:'flex', alignItems:'baseline', columnGap:'3px'}}>
        <h2 className="parent-title">Emergency Supplies Inventory</h2>
        <ToolTipCreator name={"Disaster_Emergency_Supplies_Inventory"}/>
      </div>
        {/* <div className="parent-icon-container">
          <img
            src={helpIcon}
            alt="help icon"
            width="18.67px"
            height="18.67px"
          />
        </div> */}
      </div>

     {collapseableTables.map((table) => {
      const moduleTitle = table.originalTitle || table.title;
      return (
        <CollapseableTable
          title={table.title}
          key={table.key}
          onClick={() => showModal(moduleTitle)}
        >
          <Table
            columns={AllColumnsData[moduleTitle]}
            dataSource={tableDataObj[moduleTitle]}
          />
        </CollapseableTable>
      );
    })}

      <CustomModal
        show={isModalVisible}
        fields={attributesData && attributesData}
        modalTitle={modalTitle}
        close={handelCloseModal}
        onChange={handleChange}
        onSelectChange={handleItemsInfoSelect}
        submitData={modalTitle !== "Update" ? createAttributes : updateRecord}
        selectedRowData={formData && formData}
        handleItemsInfoImageChange={formData}
        loading={loadingState}
      />

      <NewLoader isLoading={loading} />
    </div>
  );
}
